import React from "react";

const ContainerCard = ({
  step = 0,
  totalSteps = 0,
  heading,
  subheading,
  onPrev,
  children,
  isBT30,
  handleActionChange,
  isSessionSelected,
  isAvailableCountLoading,
  isPowerUser,
  availableSeats,
}) => {
  
  const shouldDisableButton = () => {
    if (step !== 3) {
      return false;
    }

    return (
      isAvailableCountLoading || !isSessionSelected || availableSeats === 0
    );
  };

  return (
    <div className="container-card">
      <div className="container-header">
        <div>
          <div className="container-stepper">
            {step !== 1 && (
              <iconify-icon
                icon="zmdi:chevron-left"
                width="7"
                tabIndex={0}
                aria-label="Previous"
                onKeyDown={(e) => {
                  // support Enter/Space activation
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onPrev();
                  }
                }}
                style={{ paddingRight: "8px", cursor: "pointer" }}
                onClick={onPrev}
              />
            )}
            STEP {step === 5 ? 3 : step} OF {totalSteps}
          </div>
          <div className="container-heading mt-1">{heading}</div>
          <div className="container-subheading">{subheading}</div>
        </div>
        {isBT30 && (step === 3 || step === 4) && (
          <div style={{ marginRight: "20px", marginBottom: "8px" }}>
            <button
              disabled={shouldDisableButton(
                step,
                isAvailableCountLoading,
                isSessionSelected,
                availableSeats
              )}
              className={
                shouldDisableButton(
                  step,
                  isAvailableCountLoading,
                  isSessionSelected,
                  availableSeats
                )
                  ? "button-disabled"
                  : "button"
              }
              style={{ width: "max-content", minWidth: "100px" }}
              onClick={() => handleActionChange()}
            >
              {step === 3 ? "Next" : "Confirm Courses"}
            </button>
          </div>
        )}
      </div>
      <div className="container-card-body">{children}</div>
    </div>
  );
};

export default ContainerCard;
